import { ModuleWithProviders, NgModule } from '@angular/core';

import { NzAffixModule } from 'ant-reset-private/affix';
import { NzAlertModule } from 'ant-reset-private/alert';
import { NzAnchorModule } from 'ant-reset-private/anchor';
import { NzAutocompleteModule } from 'ant-reset-private/auto-complete';
import { NzAvatarModule } from 'ant-reset-private/avatar';
import { NzBackTopModule } from 'ant-reset-private/back-top';
import { NzBadgeModule } from 'ant-reset-private/badge';
import { NzBreadCrumbModule } from 'ant-reset-private/breadcrumb';
import { NzButtonModule } from 'ant-reset-private/button';
import { NzCalendarModule } from 'ant-reset-private/calendar';
import { NzCardModule } from 'ant-reset-private/card';
import { NzCarouselModule } from 'ant-reset-private/carousel';
import { NzCascaderModule } from 'ant-reset-private/cascader';
import { NzCheckboxModule } from 'ant-reset-private/checkbox';
import { NzCollapseModule } from 'ant-reset-private/collapse';
import { NzCommentModule } from 'ant-reset-private/comment';
import { NzNoAnimationModule, NzWaveModule } from 'ant-reset-private/core';
import { NzDatePickerModule } from 'ant-reset-private/date-picker';
import { NzDescriptionsModule } from 'ant-reset-private/descriptions';
import { NzDividerModule } from 'ant-reset-private/divider';
import { NzDrawerModule } from 'ant-reset-private/drawer';
import { NzDropDownModule } from 'ant-reset-private/dropdown';
import { NzEmptyModule } from 'ant-reset-private/empty';
import { NzFormModule } from 'ant-reset-private/form';
import { NzGridModule } from 'ant-reset-private/grid';
import { NzI18nModule } from 'ant-reset-private/i18n';
import { NzIconModule } from 'ant-reset-private/icon';
import { NzInputModule } from 'ant-reset-private/input';
import { NzInputNumberModule } from 'ant-reset-private/input-number';
import { NzLayoutModule } from 'ant-reset-private/layout';
import { NzListModule } from 'ant-reset-private/list';
import { NzMentionModule } from 'ant-reset-private/mention';
import { NzMenuModule } from 'ant-reset-private/menu';
import { NzMessageModule } from 'ant-reset-private/message';
import { NzModalModule } from 'ant-reset-private/modal';
import { NzNotificationModule } from 'ant-reset-private/notification';
import { NzPageHeaderModule } from 'ant-reset-private/page-header';
import { NzPaginationModule } from 'ant-reset-private/pagination';
import { NzPopconfirmModule } from 'ant-reset-private/popconfirm';
import { NzPopoverModule } from 'ant-reset-private/popover';
import { NzProgressModule } from 'ant-reset-private/progress';
import { NzRadioModule } from 'ant-reset-private/radio';
import { NzRateModule } from 'ant-reset-private/rate';
import { NzResizableModule } from 'ant-reset-private/resizable';
import { NzSelectModule } from 'ant-reset-private/select';
import { NzSkeletonModule } from 'ant-reset-private/skeleton';
import { NzSliderModule } from 'ant-reset-private/slider';
import { NzSpinModule } from 'ant-reset-private/spin';
import { NzStatisticModule } from 'ant-reset-private/statistic';
import { NzStepsModule } from 'ant-reset-private/steps';
import { NzSwitchModule } from 'ant-reset-private/switch';
import { NzTableModule } from 'ant-reset-private/table';
import { NzTabsModule } from 'ant-reset-private/tabs';
import { NzTagModule } from 'ant-reset-private/tag';
import { NzTimePickerModule } from 'ant-reset-private/time-picker';
import { NzTimelineModule } from 'ant-reset-private/timeline';
import { NzToolTipModule } from 'ant-reset-private/tooltip';
import { NzTransferModule } from 'ant-reset-private/transfer';
import { NzTreeModule } from 'ant-reset-private/tree';
import { NzTreeSelectModule } from 'ant-reset-private/tree-select';
import { NzUploadModule } from 'ant-reset-private/upload';

export * from 'ant-reset-private/affix';
export * from 'ant-reset-private/alert';
export * from 'ant-reset-private/anchor';
export * from 'ant-reset-private/auto-complete';
export * from 'ant-reset-private/avatar';
export * from 'ant-reset-private/back-top';
export * from 'ant-reset-private/badge';
export * from 'ant-reset-private/breadcrumb';
export * from 'ant-reset-private/button';
export * from 'ant-reset-private/calendar';
export * from 'ant-reset-private/card';
export * from 'ant-reset-private/carousel';
export * from 'ant-reset-private/cascader';
export * from 'ant-reset-private/checkbox';
export * from 'ant-reset-private/collapse';
export * from 'ant-reset-private/comment';
export * from 'ant-reset-private/core';
export * from 'ant-reset-private/date-picker';
export * from 'ant-reset-private/descriptions';
export * from 'ant-reset-private/divider';
export * from 'ant-reset-private/drawer';
export * from 'ant-reset-private/drawer';
export * from 'ant-reset-private/dropdown';
export * from 'ant-reset-private/empty';
export * from 'ant-reset-private/form';
export * from 'ant-reset-private/grid';
export * from 'ant-reset-private/i18n';
export * from 'ant-reset-private/icon';
export * from 'ant-reset-private/input-number';
export * from 'ant-reset-private/input';
export * from 'ant-reset-private/layout';
export * from 'ant-reset-private/list';
export * from 'ant-reset-private/mention';
export * from 'ant-reset-private/menu';
export * from 'ant-reset-private/message';
export * from 'ant-reset-private/modal';
export * from 'ant-reset-private/notification';
export * from 'ant-reset-private/page-header';
export * from 'ant-reset-private/pagination';
export * from 'ant-reset-private/popconfirm';
export * from 'ant-reset-private/popover';
export * from 'ant-reset-private/progress';
export * from 'ant-reset-private/radio';
export * from 'ant-reset-private/rate';
export * from 'ant-reset-private/select';
export * from 'ant-reset-private/skeleton';
export * from 'ant-reset-private/slider';
export * from 'ant-reset-private/spin';
export * from 'ant-reset-private/statistic';
export * from 'ant-reset-private/steps';
export * from 'ant-reset-private/switch';
export * from 'ant-reset-private/table';
export * from 'ant-reset-private/tabs';
export * from 'ant-reset-private/tag';
export * from 'ant-reset-private/time-picker';
export * from 'ant-reset-private/time-picker';
export * from 'ant-reset-private/timeline';
export * from 'ant-reset-private/tooltip';
export * from 'ant-reset-private/transfer';
export * from 'ant-reset-private/tree-select';
export * from 'ant-reset-private/tree';
export * from 'ant-reset-private/upload';
export * from 'ant-reset-private/resizable';

export * from './version';

@NgModule({
  exports: [
    NzButtonModule,
    NzCalendarModule,
    NzGridModule,
    NzSwitchModule,
    NzSelectModule,
    NzMenuModule,
    NzMentionModule,
    NzAnchorModule,
    NzAffixModule,
    NzDropDownModule,
    NzLayoutModule,
    NzBreadCrumbModule,
    NzPaginationModule,
    NzStepsModule,
    NzInputModule,
    NzCheckboxModule,
    NzInputNumberModule,
    NzSliderModule,
    NzRateModule,
    NzBadgeModule,
    NzRadioModule,
    NzAlertModule,
    NzSpinModule,
    NzPageHeaderModule,
    NzProgressModule,
    NzTabsModule,
    NzIconModule,
    NzCardModule,
    NzAvatarModule,
    NzTimelineModule,
    NzTransferModule,
    NzCarouselModule,
    NzCollapseModule,
    NzCommentModule,
    NzTableModule,
    NzDatePickerModule,
    NzDividerModule,
    NzDrawerModule,
    NzFormModule,
    NzListModule,
    NzI18nModule,
    NzUploadModule,
    NzAutocompleteModule,
    NzTagModule,
    NzMessageModule,
    NzNotificationModule,
    NzPopoverModule,
    NzToolTipModule,
    NzPopconfirmModule,
    NzModalModule,
    NzBackTopModule,
    NzCascaderModule,
    NzTreeModule,
    NzTreeSelectModule,
    NzTimePickerModule,
    NzWaveModule,
    NzNoAnimationModule,
    NzSkeletonModule,
    NzStatisticModule,
    NzEmptyModule,
    NzDescriptionsModule,
    NzResizableModule
  ]
})
export class NgZorroAntdModule {
  /**
   * @deprecated Use `NgZorroAntdModule` instead.
   */
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: NgZorroAntdModule
    };
  }
}
